function stubArray() {
  return [];
}
export {
  stubArray as default
};
